module.exports = __webpack_public_path__ + "static/media/click-high-01.62790940.mp3";